export default __webpack_public_path__ + "static/media/popupCard@5.56c65bdd.png";